<template>
    <div class="row gx-3">
        <div class="col-12 justify-content-between align-items-center fitting-date mb-2">
            <span class="small d-block mb-1 fw-light" v-if="hideLabels != true">Select a date</span>
            <div class="position-relative">
                <Field v-slot="{ value }" name="app_date" as="select" class="form-select cursor-pointer flex-fill" v-model="selectedAppDate" @change="reloadFittingTimes($event)" :class="{'error': errors?.app_date}">
                    <option disabled selected value="">Select a day</option>
                    <option v-for="item, key in fitter.fitting_days" :key="item" :value="key">{{ item }}</option>
                </Field>
                <div class="error-msg">{{ errors?.app_date }}</div>
            </div>    
        </div>
        <div class="col-12 justify-content-between align-items-center fitting-date mb-2" v-if="mobileFittingSlots[fitter.cal_account_number] || fitter.mobile == 0">
            <span class="small d-block mb-1 fw-light" v-if="hideLabels != true">Select a time</span>
            <div class="position-relative">
                <Field name="app_time" as="select" class="form-select cursor-pointer flex-fill" :disabled="selectedAppDate == ''" v-model="selectedAppTime" @change="updateFittingTime == true ? updateBasketFittingTime($event) : ''" :class="{'error': errors?.app_time}">
                    <option disabled value="">Select a time</option>
                    <option v-for="item, key in appTimes" :key="item" :value="key">{{ item }}</option>
                </Field>
                <div class="error-msg">{{ errors?.app_time }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Field } from 'vee-validate';
    import fitterDateTime from '@shared/mixins/fitterDateTime';

    export default {
        props: [
            'fitter',
            'mobileFittingSlots',
            'route',
            'customSlotCount',
            'updateFittingDate',
            'updateFittingTime',
            'selectedFittingDate',
            'selectedFittingTime',
            'selectedFittingEndTime',
            'fittingTimes',
            'errors',
            'hideLabels'
        ],
        mixins: [fitterDateTime],
        components: {
            Field
        }
    }
</script>